/* eslint-disable object-curly-newline */
import * as React from 'react';
import BaseDataTable from '../common/BaseDataTable';

const columns = [
  {
    field: 'result',
    headerName: 'Result',
    width: 120,
  },
  {
    field: 'reservationId',
    headerName: 'Res. ID',
    width: 140,
  },
  {
    field: 'arrivalDate',
    headerName: 'Arrival Date',
    width: 180,
  },
  {
    field: 'departureDate',
    headerName: 'Departure Date',
    width: 180,
  },
  {
    field: 'firstName',
    headerName: 'First Name',
    width: 160,
  },
  {
    field: 'lastName',
    headerName: 'Last Name',
    width: 160,
  },
  {
    field: 'email',
    headerName: 'Email',
    width: 150,
  },
  {
    field: 'phoneNumber',
    headerName: 'Phone',
    width: 150,
  },
  {
    field: 'street',
    headerName: 'Street',
    width: 150,
  },
  {
    field: 'city',
    headerName: 'City',
    width: 150,
  },
  {
    field: 'state',
    headerName: 'State',
    width: 150,
  },
  {
    field: 'postalCode',
    headerName: 'Postal Code',
    width: 180,
  },
  {
    field: 'country',
    headerName: 'Country',
    width: 150,
  },
];

export default function ReservationTable({ rows, result }) {
  return (
    <div style={{ height: 400, width: '100%' }}>
      <BaseDataTable
        rows={rows}
        columns={!result ? columns.slice(1) : columns}
      />
    </div>
  );
}
